// src/pages/solutions/SolutionDetailPage.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams, useLocation  } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material'; // 引入 MUI 组件

const SolutionDetailPage = () => {
  const { solutionId } = useParams();
  const location = useLocation();
  const [loading, setLoading] = useState(true); // 添加加载状态
  const [contentType, setContentType] = useState('');
  const [contentPreview, setContentPreview] = useState('');

  useEffect(() => {
    document.title = '解决方案 - 责联网--产品大师智库';
  }, [location.pathname]);

  useEffect(() => {
    setLoading(true); // 开始加载时设置 loading 为 true
    const iframeUrl = `http://localhost:3000/solutions/${solutionId}/view`;

    axios.get(iframeUrl)
      .then(response => {
        setLoading(false); // 加载成功后设置 loading 为 false
        setContentType(response.headers['content-type']); // 获取 Content-Type
        setContentPreview(response.data.substring(0, 200)); // 截取内容前 200 个字符作为预览
        console.log(`请求URL: ${iframeUrl}`);
        console.log(`Content-Type: ${response.headers['content-type']}`);
        console.log('Content Preview (前 200 字符):', response.data.substring(0, 200) + '...');

        // 检查是否为 HTML (更严谨的判断可以根据 Content-Type 更详细地判断)
        if (response.headers['content-type'] && response.headers['content-type'].includes('text/html')) {
          console.log('返回内容可能是 HTML');
        } else {
          console.log('返回内容可能不是 HTML');
        }
      })
      .catch(error => {
        setLoading(false); // 加载失败也设置 loading 为 false
        console.error('请求内容出错:', error);
        setContentType('error'); // 设置 Content-Type 为 error 表示请求出错
        setContentPreview('加载内容失败');
      });
  }, [solutionId]);

  return (
    <Box sx={{ width: '100%', height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {loading ? (
        <CircularProgress /> // 加载中显示 MUI CircularProgress
      ) : (
        <iframe
          src={`http://localhost:3000/solutions/${solutionId}/view`}
          title="Solution Detail"
          width="100%"
          height="100%"
          style={{ border: 'none' }}
        />
      )}
    </Box>
  );
};
//   const [htmlContent, setHtmlContent] = useState('');  

//   console.log('solutionId prop:', solutionId); // <-- ADD THIS console.log STATEMENT - Inspect solutionId prop

//   const [solution, setSolution] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();
//   useEffect(() => {
//     const fetchHtml  = async () => {
//       setLoading(true);
//       try {
//         const response = await axios.get(`/solutions/${solutionId}/view`, { // 请求 /view 接口
//             headers: { 'Accept': 'text/html' } // 告诉服务器返回 HTML
//         });
// //        setSolution(response.data);
//         setHtmlContent(response.data);
//         setLoading(false);
//       } catch (error) {
//         if (error.response && error.response.status === 403) {
//           setError(error.response.data.message);
//         } else if (error.response && error.response.status === 401) {
//           navigate('/login');
//         } else {
//           console.error('获取解决方案详情失败，ID:'+solutionId, error);
//           setError('获取解决方案详情失败,ID：'+solutionId);
//         }
//         setLoading(false);
//       }
//     };
//     fetchHtml();
// //    fetchSolution();
//   },  [solutionId, navigate]); // 依赖项保持 solutionId, navigate

//   return (
//     <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
//   );
// };

export default SolutionDetailPage;